import React from 'react'
import styled from 'styled-components'
import { Text } from '@lmc/ui-kit/src/general'
import { useTranslation } from 'react-i18next'
import { NAMESPACE } from 'locale'
import { FormCard } from '@lmc/ui-kit'

type CommentDetailContentProps = {
  record: any
  medicationName: string
}

export const CommentDetailContent: React.FC<CommentDetailContentProps> = ({
  record
}) => {
  const { t } = useTranslation(NAMESPACE.EMAR_V2)

  const description = record?.description || record?.title || ''
  const outcome = record?.outcome || ''
  const recordedBy = record?.loggedBy
  const recordedByName = recordedBy
    ? `${recordedBy.name?.first || ''} ${recordedBy.name?.last || ''}`.trim()
    : ''
  const expectedStock = record?.expectedStock || record?.amount2 || 0
  const stockUpdated = record?.stockUpdated
  const stockQuantityRemoved = record?.stockQuantityRemoved || 0
  const stockQuantityLeft = record?.stockQuantityLeft || record?.amount2 || 0
  const stockUnit =
    record?.stockUnit || record?.stockQuantityType || t('TABLETS')

  // Build stock updated text
  const stockUpdatedText =
    stockUpdated && stockQuantityRemoved > 0
      ? `${stockQuantityRemoved} ${stockUnit} ${t('REMOVED_FROM_STOCK')}, ${stockQuantityLeft} ${stockUnit} ${t('LEFT')}`
      : t('NOT_APPLICABLE')

  return (
    <FormCard level={2}>
      <InfoRow>
        <FullWidthSection>
          <StyledLabel level={2}>{t('DESCRIPTION')}</StyledLabel>
          <Text>{description || '-'}</Text>
        </FullWidthSection>
      </InfoRow>
      <InfoRow>
        <InfoSection>
          <StyledLabel level={2}>{t('RECORDED_BY')}</StyledLabel>
          <Text weight="bold">{recordedByName || '-'}</Text>
        </InfoSection>
        <InfoSection>
          <StyledLabel level={2}>{t('OUTCOME')}</StyledLabel>
          <Text weight="bold">{outcome || '-'}</Text>
        </InfoSection>
        <InfoSection>
          <StyledLabel level={2}>{t('EXPECTED_STOCK')}</StyledLabel>
          <Text weight="bold">
            {expectedStock !== undefined
              ? `${expectedStock} ${stockUnit}`
              : '-'}
          </Text>
        </InfoSection>
      </InfoRow>
      <InfoRow>
        <FullWidthSection>
          <StyledLabel level={2}>{t('STOCK_UPDATED')}</StyledLabel>
          <Text weight="bold">{stockUpdatedText}</Text>
        </FullWidthSection>
      </InfoRow>
    </FormCard>
  )
}

const InfoRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 24px;
`

const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 185px;
`

const FullWidthSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const StyledLabel = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color5};
`
